<div style="height: 100%; width: 100%;">
  <h1>Agregar Observaciones</h1>
  <mat-form-field class="example-full-width" style="width: 100%; height: 50%;">
    <mat-label>Observaciones</mat-label>
    <textarea matInput placeholder="Observaciones" [(ngModel)]="observaciones"></textarea>
  </mat-form-field>
  <div style="width: 100%; text-align: center">
    <mat-card-actions>
      <button mat-raised-button (click)="actualizar()" color="primary" style="position: relative;
      right: 10px;" [disabled]="observaciones.length < 10">Actualizar</button>

      <button mat-raised-button (click)="cancelar()" color="primary">Cancelar</button>
    </mat-card-actions>
  </div>
</div>